import useSearchParam, { SearchParamActions } from './useSearchParam';

export default function useIntArraySearchParam(
  name: string
): [number | undefined, SearchParamActions<number | undefined>] {
  return useSearchParam<number | undefined>(name, {
    initialize: (v: string): number | undefined =>
      v ? parseInt(v, 10) : undefined,
  });
}
